import { VisualizatorSettings } from "../../visualizator-settings";
import { ObjectCreator } from "../../../../../../../web-graphics";

export class SignalPlotSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    const simpleFields = ["id_signal", "id_isoline", "type", "fillType", "pointCount"];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (simpleFields.includes(key)) {
        this[key] = settings[key];
      } else if (key == "color") {
        this.color = ObjectCreator.deepCopy(settings.color);
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new SignalPlotSettings(this);
  }
}
